import React from 'react'
import PropTypes from 'prop-types'
import { message } from 'antd'
import WrappedModal from '@/components/WrappedModal'
import { createTuinaMember, updateTuinaMember } from '@/service/tuina'
import MemberForm from './MemberForm'

class MemberModal extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    actType: PropTypes.oneOf(['create', 'edit']),
    record: PropTypes.object,
    storeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onSuccess: PropTypes.func
  }

  static defaultProps = {
    actType: 'create'
  }

  handleOk = async (form) => {
    const { actType, record, onSuccess } = this.props
    const fields = await form.current.validateFields()

    switch (actType) {
      case 'create': {
        const response = await createTuinaMember(fields)
        message.success('已新增')
        if (typeof onSuccess === 'function') onSuccess((response && response.data) || fields)
        break
      }
      case 'edit':
        await updateTuinaMember(record.id, {
          name: fields.name,
          gender: fields.gender,
          phone: fields.phone,
          birthday: fields.birthday
        })
        message.success('已保存')
        if (typeof onSuccess === 'function') onSuccess()
        break
      default:
        return
    }
  }

  render () {
    const { children, actType, record, storeId } = this.props
    const memberName = (record && record.name) || ''
    const title = actType === 'edit' ? `编辑 ${memberName} 会员` : '新增会员'
    return (
      <WrappedModal
        children={children}
        title={title}
        okText={actType === 'edit' ? '保存' : '新增'}
        okButtonProps={{ size: 'large' }}
        cancelButtonProps={{ size: 'large' }}
        width={560}
        zIndex={1100}
        baseComponent={<MemberForm />}
        baseProps={{ actType, record, storeId }}
        onOk={this.handleOk}
      />
    )
  }
}

export default MemberModal
